import {ForecastDetailResponse} from '../../services/botService';

export const getTimeframeMs = (timeframe?: string | null): number => {
    switch ((timeframe || '5m').toLowerCase()) {
        case '1m':
            return 60_000;
        case '1h':
            return 3_600_000;
        case '4h':
            return 14_400_000;
        case '1d':
            return 86_400_000;
        case '5m':
        default:
            return 300_000;
    }
};

export interface ForecastConnector {
    startTime: number;
    startPrice: number;
    endTime: number;
    endPrice: number;
}

type ConnectorSource = Pick<
    ForecastDetailResponse,
    'decisionTime' | 'anchorPrice' | 'takeProfit' | 'forecast'
>;

/**
 * 构造「锚点 → (持仓截止时间, 目标止盈价)」的斜向连线。
 * 仅当开关开启且锚点、目标止盈、持仓时间三者齐全时返回有效连线。
 */
export const buildForecastConnector = (
    detail: ConnectorSource,
    show: boolean
): ForecastConnector | undefined => {
    const targetTakeProfit = detail.forecast?.takeProfitPrice ?? detail.takeProfit ?? undefined;
    const holdingEndTime = detail.forecast?.expectedHoldingMinutes
        ? detail.decisionTime + detail.forecast.expectedHoldingMinutes * 60_000
        : undefined;
    if (!show
        || detail.anchorPrice === null
        || detail.anchorPrice === undefined
        || targetTakeProfit === undefined
        || holdingEndTime === undefined) {
        return undefined;
    }
    return {
        startTime: detail.decisionTime,
        startPrice: Number(detail.anchorPrice),
        endTime: holdingEndTime,
        endPrice: Number(targetTakeProfit),
    };
};

export const canShowModelPreview = (detail: ConnectorSource): boolean =>
    buildForecastConnector(detail, true) !== undefined;

export const splitValidationMessages = (
    messages: string[]
): { warnings: string[]; errors: string[] } => ({
    warnings: messages.filter(item => item.startsWith('WARN_')),
    errors: messages.filter(item => !item.startsWith('WARN_')),
});
